import { Checkbox } from '@/components/ui/checkbox'

export interface AutopayOffer {
  default_checked: false
  amount: string
  amount_cents: number
  frequency: string
  cancellation_method: string
  disclosure_version: string
  disclosure_text: string
}

export function AutopayConsentChoice({
  offer,
  checked,
  onCheckedChange,
}: {
  offer: AutopayOffer
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}) {
  return (
    <div className="flex items-start gap-3 rounded-md border border-border bg-muted/30 p-4">
      <Checkbox
        id="enroll-autopay"
        checked={checked}
        onCheckedChange={(value) => onCheckedChange(value === true)}
        aria-describedby="autopay-disclosure"
      />
      <div className="space-y-1">
        <label htmlFor="enroll-autopay" className="text-body-sm font-semibold text-foreground">
          Enroll in Autopay
        </label>
        <p id="autopay-disclosure" className="text-caption leading-5 text-muted-foreground">
          {offer.disclosure_text}
        </p>
      </div>
    </div>
  )
}
